import Api from 'client/api/v2/Api';
import axios from 'axios';

class AccountManagerCalendarApi extends Api {
  constructor() {
    super();
    this.baseUrl = '/api/v2/accountManagerCalendar';
  }

  /**
   * @description
   * Will return an empty object if no account manager was found,
   * otherwise an object with the sales person's name and PublicCalendarUrl url
   */
  fetch(orgId) {
    return this.initialize()
      .then(() => axios.get(`${this.baseUrl}/${orgId}`));
  }
}

export default new AccountManagerCalendarApi();
